import { render } from "./FlowPanel.vue?vue&type=template&id=2b97bd24&scoped=true&ts=true"
import script from "./FlowPanel.vue?vue&type=script&lang=ts"
export * from "./FlowPanel.vue?vue&type=script&lang=ts"

import "./FlowPanel.vue?vue&type=style&index=0&id=2b97bd24&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97bd24"]])

export default __exports__